import SelectTAR from "../../../../src/client/katnh/widgets/SelectTAR.js";
import * as React from 'react';
export default {
  SelectTAR,
  React
};